module.exports = __webpack_public_path__ + "static/media/1.ed00a628.glb";